import React from "react";
import Land from "../../images/ceter1.jpg";
import BlogButtonWithMouseDemo from "../BlogButton";

export default function FeatureSplitSection() {
  return (
    <div className="bg-gradient-to-b from-slate-50 to-slate-100 py-16">
      <section className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-4xl lg:text-4xl font-bold text-[#1B0727] mb-4">
            Featured Projects
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-amber-400 to-amber-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
          {/* Left Column - Elite Residency */}
          <div className="space-y-6 order-2 lg:order-1 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-slate-200">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-3 h-8 bg-amber-500 rounded-full"></div>
              <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-900 to-indigo-800">
                Elite Residency
              </h3>
            </div>
            <p className="text-sm uppercase tracking-wider text-amber-800 font-medium">
              BMRDA APPROVED PLOTS
            </p>

            <ul className="space-y-4">
              {[
                "Legally approved 30x40 (1200 sqft) plots",
                "Gated community with 24/7 security",
                "Asphalted roads, streetlights, water & drainage",
                "Excellent access to Tumkur Road, STRR, and Bangalore City",
                "High appreciation potential in a rapidly developing area",
                "An exclusive layout of BMRDA approved plots in Chikka Madure, near Sri Shanimahathma Temple",
              ].map((text, idx) => (
                <li key={idx} className="flex items-start space-x-3 group">
                  <div className="w-2.5 h-2.5 bg-amber-500 rounded-full mt-2 flex-shrink-0 transform group-hover:scale-125 transition-transform"></div>
                  <p className="text-slate-700 group-hover:text-slate-900 transition-colors">
                    {text}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Center Image */}
          <div className="flex justify-center order-1 lg:order-2 relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-400 to-purple-500 rounded-3xl opacity-20 group-hover:opacity-30 blur-md transition-opacity"></div>
            <img
              src={Land}
              alt="Project Presentation"
              title="Project Presentation"
              className="relative rounded-2xl w-full h-80 lg:h-[500px] object-cover shadow-xl transform group-hover:scale-[1.02] transition-transform z-10"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent rounded-2xl z-20"></div>
            <div className="absolute bottom-6 left-6 right-6 text-white z-30">
              <p className="text-sm font-light opacity-90">
                Premium Developments
              </p>
              <h4 className="text-2xl font-bold">Excellence in Living</h4>
            </div>
          </div>

          {/* Right Column - Green Woods */}
          <div className="space-y-6 order-3 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-slate-200">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-8 bg-emerald-500 rounded-full"></div>
                <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-800 to-teal-700">
                  Green Woods
                </h3>
              </div>
              {/* Clickable Button */}
              <BlogButtonWithMouseDemo />
            </div>

            <p className="text-sm uppercase tracking-wider text-emerald-800 font-medium">
              ORGANIC FARM VILLAS
            </p>

            <ul className="space-y-4">
              {[
                "Large organic-friendly plots",
                "Yoga and meditation zones",
                "Natural surroundings in a gated layout",
                "Good road access and connectivity to Bangalore",
                "Ideal for weekend homes or long-term real estate planning",
                "Green Woods is a thoughtfully planned farm villa project that blends modern living with nature.",
              ].map((text, idx) => (
                <li key={idx} className="flex items-start space-x-3 group">
                  <div className="w-2.5 h-2.5 bg-emerald-500 rounded-full mt-2 flex-shrink-0 transform group-hover:scale-125 transition-transform"></div>
                  <p className="text-slate-700 group-hover:text-slate-900 transition-colors">
                    {text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
